import { BeeModel } from "../../beeorm/BeeModel";
import type { BookModelManagerOptions } from "../modelManager.types";
import { BookModelCollection } from "./BookModelCollection";

export class BookModel extends BeeModel {
  declare options: BookModelManagerOptions;
  static getCollectionClass() {
    return BookModelCollection as typeof BookModelCollection<BookModel>;
  }

  getAsSelectOption({
    label = "title",
    value = "id",
  }: Partial<{ label: string; value: string }> = {}) {
    return {
      id: this.id + "",
      label: this.get<string>(label)!,
      value: "" + this.get(value),
    };
  }
}
